import script from "./LoadMoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadMoreButton.vue?vue&type=script&setup=true&lang=js"

import "./LoadMoreButton.vue?vue&type=style&index=0&id=4f04830a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f04830a"]])

export default __exports__